// src/components/StaticPageLayout.tsx

import { Link } from 'react-router-dom';
import { ReactNode } from 'react';

interface StaticPageLayoutProps {
  children: ReactNode;
  title: string;
}

export const StaticPageLayout = ({ children, title }: StaticPageLayoutProps) => {
  return (
    <div className="min-h-screen bg-white text-gray-800">
      {/* ヘッダー */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <Link to="/" className="flex-shrink-0">
              <img
                src="/images/sidepocket_Logo.png"
                alt="sidepocket Logo"
                className="h-8 w-auto"
              />
            </Link>
            <div className="flex items-center gap-4">
              <Link
                to="/login"
                className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors"
              >
                ログイン
              </Link>
              <Link
                to="/signup"
                className="px-5 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-bold rounded-md shadow-sm transition-colors"
              >
                無料で始める
              </Link>
            </div>
          </div>
        </div>
      </header>

      {/* メインコンテンツ */}
      <main className="py-12 sm:py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <article className="prose prose-gray max-w-none">
            <h1 className="text-3xl font-bold text-gray-900 mb-8">{title}</h1>
            {children}
          </article>
        </div>
      </main>

      {/* フッター */}
      <footer className="bg-gray-100">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="text-center text-sm text-gray-500">
            <div className="flex justify-center items-center mb-4">
              <img
                src="/images/sidepocket_symbol.png"
                alt="sidepocket Symbol"
                className="h-6 w-auto"
              />
            </div>
            <div className="flex justify-center gap-6">
              <Link to="/terms" className="hover:underline">
                利用規約
              </Link>
              <Link to="/privacy" className="hover:underline">
                プライバシーポリシー
              </Link>
              <Link to="/contact" className="hover:underline">
                お問い合わせ
              </Link>
            </div>
            <p className="mt-4">&copy; {new Date().getFullYear()} sidepocket. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};
